export const INIT_BANNER_LIST_REQUEST = 'INIT_BANNER_LIST_REQUEST';
export const SET_BANNER_LIST = 'SET_BANNER_LIST';
export const ERROR_BANNER_LIST = 'ERROR_BANNER_LIST';
export const ADD_BANNER = 'ADD_BANNER';
export const ERROR_ADD_BANNER = 'ERROR_ADD_BANNER';
export const DELETE_BANNER = 'DELETE_BANNER';
export const ERROR_DELETE_BANNER = 'ERROR_DELETE_BANNER';

export const initBannerListRequest = () => ({
  type: INIT_BANNER_LIST_REQUEST
});

export const setBannerList = (data) => ({
  type: SET_BANNER_LIST,
  payload: data
});

export const errorBannerList = (message) => ({
  type: ERROR_BANNER_LIST,
  payload: message
});

export const addBanner = (data) => ({
  type: ADD_BANNER,
  payload: data
});

export const errorAddBanner = (message) => ({
  type: ERROR_ADD_BANNER,
  payload: message
});

export const deleteBanner = (bannerId) => ({
  type: DELETE_BANNER,
  payload: bannerId
});

export const errorDeleteBanner = (message) => ({
  type: ERROR_DELETE_BANNER,
  payload: message
});
